import { ColOrderValue } from "types/generic/types";

interface GetColOrderClassNamesProps {
  xsColOrder?: ColOrderValue;
  smColOrder?: ColOrderValue;
  mdColOrder?: ColOrderValue;
  lgColOrder?: ColOrderValue;
  xlColOrder?: ColOrderValue;
}

export const getColOrderClassNames = ({
  xsColOrder,
  smColOrder,
  mdColOrder,
  lgColOrder,
  xlColOrder,
}: GetColOrderClassNamesProps) => {
  return {
    [`order-${xsColOrder}`]: !!xsColOrder,
    [`order-sm-${smColOrder}`]: !!smColOrder,
    [`order-md-${mdColOrder}`]: !!mdColOrder,
    [`order-lg-${lgColOrder}`]: !!lgColOrder,
    [`order-xl-${xlColOrder}`]: !!xlColOrder,
  };
};
